import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const ProductTileWater = ({ data }) => (
  
  <div className="product">
    <div className="row">
      <div className="col-md-6">
        <div className="product-image">
          <picture className="picture picture--result">
            <source srcSet={data.image} />
            <img className="w-100" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="" />
          </picture>
        </div>
      </div>
      <div className="col-md-5">
        <div>
          <h2 className="headline headline--h2 text-uppercase">{data.headline}</h2>
          <h3 className="headline headline--h3"><span dangerouslySetInnerHTML={{ __html: data.subheadline }} /><br />{data.textblock_1st_text}</h3>
          {data.textblock_list && <ul className="list list--mb">{data.textblock_list.map((item,j) =>
            <li key={j}>{item.item}</li>
          )}</ul> }
          <p dangerouslySetInnerHTML={{__html: data.textblock_2nd_text}} className="text text--mbButtonsFollow"/>
          {data.links.map((link,j) => (
              <span onClick={() => tracking.event(data.headline,link.track_action)} key={j}>
                <a target="_blank" onClick={link.applyHatch ? (event) => this.openModal(product, event) : null} className={'btn btn-block btn-primary button button--result ' + link.additionalClass} href={link.deeplink} ><FormattedMessage id={link.text} defaultMessage={link.text} /></a>
            </span>                      
            ))}
          
        </div>
      </div>
    </div>
  </div>

);

ProductTileWater.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ProductTileWater;



// WEBPACK FOOTER //
// ./src/components/product/ProductTileWater.js